import Button from "./Button";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export const Items = ({ user, logout }) =>
{
  let parsedUser = null;

  if (typeof user === 'string')
  {
    try
    {
      parsedUser = JSON.parse(user);
    }
    catch (e)
    {
      parsedUser = null;
    }
  }
  else
  {
    parsedUser = user;
  }

  return (
    <div className="flex items-center gap-4">
      {!!parsedUser && (
        <>
          <>{parsedUser.name} {parsedUser.surname}</>
          <Button
            icon={<LogoutOutlinedIcon />}
            handleOnClick={logout}
            title="Logout"
            className="h-[20px] w-[20px]"
          />
        </>
      )}
    </div>
  );
};
